import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Button } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';

type BottomButtonProps = {
  type?: 'submit' | 'button';
  isButtonLoading: boolean;
  onButtonClick?: () => void;
};

const BottomButton = ({ type = 'submit', isButtonLoading, onButtonClick }: BottomButtonProps) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { formState } = useFormContext();
  const step = Number(searchParams.get('step')) || 1;
  const section = Number(searchParams.get('section')) || 1;

  const handleBackStep = () => {
    if (step === 2 && section === 1) return navigate('/registration?step=1');

    if (step === 2 && section === 2) return navigate('/registration?step=2&section=1');

    if (step === 2 && section === 3) return navigate('/registration?step=2&section=2');

    if (step === 3 && section === 1) return navigate('/registration?step=2&section=3');

    if (step === 3 && section === 2) return navigate('/registration?step=3&section=1');
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, maxWidth: 500, pb: 2, ml: 2 }}>
      <Button sx={{ minWidth: '240px' }} onClick={handleBackStep} variant="outlined" disabled={isButtonLoading}>
        Kembali
      </Button>
      <LoadingButton
        type={type}
        variant="contained"
        loading={isButtonLoading}
        onClick={() => {
          onButtonClick && formState.isValid && onButtonClick();
        }}
        sx={{ minWidth: '240px' }}
      >
        Lanjut
      </LoadingButton>
    </Box>
  );
};

export default BottomButton;
